import { Log } from 'ng2-logger';
import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import { SelectAsync } from '../../../../../components/input/select/main';
import Paginate from '../../../../../components/table/paginate';
import Announce from '../../../../../components/templates/announce';
import Translator from '../../../../../core/i18n';
import { IAction, IAppState } from '../../../../../models/action/core';
import * as Actions from '../../../../../store/actions/examSession';
import { IPagedQueryS } from '../../../../../models/components/paginate';
import { IFilterAddStudent, IFilterExamStudents, IStudents } from '../../../../../models/components/add-exam-sessions';
import { Notification } from '../../../../../components/notification/main';
import AddMultiStudentModal from '../../../../../components/popup/activity-exam-student-add';
import Tooltip from '../../../../../components/tooltip/main';
import { Button } from '../../../../../components/ui-elements/main';

const T = Translator.create();
const _logger = Log.create('add session add question');

interface IAddStudentModalProps {
    currentTab: string;
    coursePageActivityId?: string;
    coursePageClassId?: string;
    examId?: string;
    examSessionId: string;
    dispatch?: any;
    addStudentDatas?: {
        filters: IPagedQueryS;
        results: IStudents[] | null;
    };
    isDefaultUpdateStudent?: number;
    publishDatas?: any;
    multiUsers?: any[]

}

interface IAddStudentModalState {
    filters: IPagedQueryS;
    isAll: boolean;
    disAllowedStudentIds: string[];
    selectedStudentIds: string[];
    searchedStudents: string[];
    isSelectAll: boolean;
    isAddStudentModalOpen: boolean;
    getAllStudents:boolean;
    addedMultiUsers: string[];
}



export class AddStudentModal extends Component<IAddStudentModalProps, IAddStudentModalState> {
    constructor(props: any) {
        super(props);

        this.state = {
            filters: {
                page: 1,
                take: 50,
                total: 0
            },
            isAll: false,
            disAllowedStudentIds: [],
            selectedStudentIds: [],
            searchedStudents: [],
            isSelectAll: false,
            isAddStudentModalOpen: false,
            getAllStudents: true,
            addedMultiUsers: []
        };

    }

    handleClick = () => {
        if(this.state.getAllStudents){
            this.setState({ getAllStudents: false})

        }
    };

    componentDidUpdate(prevProps: any) {
        if (
            prevProps.isDefaultUpdateStudent &&
            this.props.isDefaultUpdateStudent &&
            prevProps.isDefaultUpdateStudent !== this.props.isDefaultUpdateStudent
        ) {
            this.setState({
                isAll: false,
                selectedStudentIds: [],
                disAllowedStudentIds: [],
                searchedStudents: [],
                isSelectAll: false,
                filters: {
                    page: 1,
                    take: 50,
                    total: 0
                }
            });
        }
    }

    getStudents = async (filters: IFilterAddStudent, paging: IPagedQueryS) => {
        filters.examSessionId = this.props.examSessionId;
        this.props.dispatch(Actions.ExamSessionAddStudentList(filters, paging, '', 'get'));

        // this.setState({ filterInitialValues: filters });
    };


    sort = async (sortkey: string, orderBy: string) => {
        const sortString = sortkey + '_' + orderBy;
        this.setState({
            ...this.state,
            filters: {
                ...this.state.filters,
                orderBy: sortString
            }
        });
        // await this.getQuestion(this.state.filterInitialValues, this.state.filters);
    };

    onPageChange = async (page: number) => {
        this.state.filters.page = page;
        this.setState(this.state);

        const filters: IFilterAddStudent = {
            examId: this.props.examId,
            examSessionId: this.props.examSessionId,
            selectedStudentIds: this.state.searchedStudents,
            isSelectAll: true
        };

        await this.getStudents(filters, this.state.filters);
    };

    onSelectStudent = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event && event.target) {
            if (!this.state.isAll) {
                const selectedIds = Object.assign([], this.state.selectedStudentIds);
                const id: string = event.currentTarget.dataset.id || '';
                if (event.target.checked && id) {
                    selectedIds.push(id);
                } else if (!event.target.checked && id) {
                    const index = selectedIds.indexOf(id);
                    if (index !== -1) {
                        selectedIds.splice(index, 1);
                    }
                }
                this.setState({ selectedStudentIds: selectedIds });
            } else {
                const disAllowedIds = Object.assign([], this.state.disAllowedStudentIds);
                const id: string = event.currentTarget.dataset.id || '';
                if (!event.target.checked && id) {
                    disAllowedIds.push(id);
                } else if (event.target.checked && id) {
                    const index = disAllowedIds.indexOf(id);
                    if (index !== -1) {
                        disAllowedIds.splice(index, 1);
                    }
                }
                if(this.state.addedMultiUsers.length>0)
                {
                    let newArr = this.state.addedMultiUsers.filter((val:any) => !disAllowedIds.includes(val));

                    this.setState({addedMultiUsers: newArr})
                }

                this.setState({ disAllowedStudentIds: disAllowedIds });
            }
        }
    };

    addSelectedStudents = () => {
        if (
            this.props.publishDatas!.activeStatus === 0 &&
            this.props.publishDatas!.isPassive === 1
        ) {
            if (
                this.props.examSessionId &&
                this.props.examId &&
                ((this.state.selectedStudentIds && this.state.selectedStudentIds.length) || this.state.isAll)
            ) {
                const filters: IFilterAddStudent = {
                    examId: this.props.examId,
                    examSessionId: this.props.examSessionId,
                    selectedStudentIds: this.state.searchedStudents,
                    isSelectAll: this.state.isSelectAll
                };

                this.props.dispatch(
                    Actions.ExamSessionAddStudent(
                        filters,
                        this.state.addedMultiUsers.length>0 ? false : this.state.isAll,
                        this.props.examSessionId,
                        this.props.examId,
                        this.state.addedMultiUsers.length>0 ? this.state.addedMultiUsers : this.state.selectedStudentIds,
                        this.addSelectedStudentsCallBack,
                        this.state.disAllowedStudentIds,
                        '',
                        'get'
                    )
                );
            }
        } else {
            Notification.setNotification('error', T.t('r_activity_exam_session_edit_error').replace('{0}', T.t('r_activity_exam_session_edit_error_students')), 'topRight');
        }
    };

    addMultiStudentsCallBack = async() =>
    {
       if (this.props.multiUsers)
       {
        let selectedUsers:string[]  = this.props.multiUsers?.map(ids => (ids.userId));
        this.setState({addedMultiUsers: selectedUsers})
        const filters: IFilterAddStudent = {
            examId: this.props.examId,
            examSessionId: this.props.examSessionId,
            selectedStudentIds: selectedUsers,
            isSelectAll: false
        };

        await this.getStudents(filters, this.state.filters);
       }
    }

    addSelectedStudentsCallBack = async () => {
        const filters: IFilterAddStudent = {
            examId: this.props.examId,
            examSessionId: this.props.examSessionId,
            selectedStudentIds: this.state.searchedStudents,
            isSelectAll: this.state.isSelectAll
        };

        await this.getStudents(filters, this.state.filters).then(() => {
            this.setState({
                selectedStudentIds: [],
                disAllowedStudentIds: [],
                isAll: false
            });

            if (this.props.examSessionId && this.props.examId) {
                const filtersGetStudents: IFilterExamStudents = {
                    examSessionId: this.props.examSessionId,
                    examId: this.props.examId,
                    searchedText: ''
                };
                this.props.dispatch(Actions.ExamSessionStudentList(filtersGetStudents, { page: 1, take: 50, total: 0 }, '', 'get'));
                if (this.props.coursePageActivityId && this.props.coursePageClassId) {
                    this.props.dispatch(
                        Actions.ExamSessionListGetAction(
                            this.props.examId,
                            this.props.coursePageActivityId,
                            this.props.coursePageClassId,
                            '',
                            'get',
                            this.props.examSessionId
                        )
                    );
                    this.props.dispatch(Actions.ExamSessionPublishDatas(this.props.examId, this.props.examSessionId, '', 'get'));
                }
            }
        });
    };

    selectAll = async (event: React.ChangeEvent<HTMLInputElement>) => {
        let selectedAllStudents: any[] = [];
        if(!this.state.isAll)
        {
            document.querySelectorAll('#radio-three-u').forEach(elem => selectedAllStudents.push(elem.getAttribute('data-id')));

        }
        this.setState({selectedStudentIds: selectedAllStudents, isAll: !this.state.isAll});

        if (event && event.target) {
            if (!event.target.checked) {
                this.setState({ disAllowedStudentIds: [] });
            }
        }
    };

    selectStudentOnChange = async (e: any) => {
        if (e) {
            const searchedStudents = this.state.searchedStudents;
            const userId: string = e.value.split('-')[0];

            if (this.props.examId && this.props.examSessionId) {
                if (!searchedStudents.includes(userId)) {
                    searchedStudents.push(userId);
                    this.setState({ searchedStudents });

                    const filters: IFilterAddStudent = {
                        examId: this.props.examId,
                        examSessionId: this.props.examSessionId,
                        selectedStudentIds: searchedStudents,
                        isSelectAll: this.state.isSelectAll
                    };
                    await this.getStudents(filters, this.state.filters);
                }
            }
        }
    };

    selectAllStudents = async () => {
        if (this.props.examId && this.props.examSessionId) {
            this.setState({ isSelectAll: true, addedMultiUsers: [] });
            const filters: IFilterAddStudent = {
                examId: this.props.examId,
                examSessionId: this.props.examSessionId,
                selectedStudentIds: this.state.searchedStudents,
                isSelectAll: true
            };
            await this.getStudents(filters, this.state.filters);

        }
    };

    addAllStudents = () => {
        if (
            this.props.publishDatas!.activeStatus === 0 &&
            this.props.publishDatas!.isPassive === 1
        ) {
            if (this.props.examSessionId && this.props.examId) {
                const filters: IFilterAddStudent = {
                    examId: this.props.examId,
                    examSessionId: this.props.examSessionId,
                    selectedStudentIds: [],
                    isSelectAll: true
                };

                this.props.dispatch(
                    Actions.ExamSessionAddStudent(
                        filters,
                        true,
                        this.props.examSessionId,
                        this.props.examId,
                        [],
                        this.addSelectedStudentsCallBack,
                        [],
                        '',
                        'get'
                    )
                );
            }
        } else {
            Notification.setNotification('error', T.t('r_activity_exam_session_edit_error').replace('{0}', T.t('r_activity_exam_session_edit_error_students')), 'topRight');
        }
    };

    clearList = () => {
        this.props.dispatch(Actions.ExamSessionAddStudentListDefault('', 'get'));
    };

    public onClickItems(val: string) {
        this.setState({
            isAddStudentModalOpen: true
        });
    }

    popUpClose = () =>
    {
        this.setState({
            isAddStudentModalOpen: false
        });
    }


    selectedStudentResults = () => {
        let selectedStudentsCount = 0;
        if(this.state.isAll){
            if(this.props.addStudentDatas?.filters){
                selectedStudentsCount = this.props.addStudentDatas.filters.total! - this.state.disAllowedStudentIds.length
            }
        }else{
            selectedStudentsCount = this.state.selectedStudentIds.length;
        }
        return(
            <div className="row mt-3 px-2">
                        <div className="row d-flex justify-content-between w-100 my-2">
                            <div className="col">
                                <div className="title ">
                                    <span className="oturum-title">{T.t('r_searching_result')}</span>
                                </div>
                            </div>
                            <div className="col">
                                <div className="title"  style={{float: 'inline-end'}}>
                                    <span className="d-flex align-items-center">
                                        {T.t('r_gen_exam_session_selected_students')} :{' '}
                                        {selectedStudentsCount}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="question-list w-100">
                            <div className="no-hover question-row w-100">
                                <div className="w-10 ">
                                    {
                                    this.props.addStudentDatas?.results &&
                                    this.props.addStudentDatas.results.length > 0 ? (
                                        <span className="tick-radio position-relative d-inline-block">
                                            <input
                                                onChange={this.selectAll}
                                                type="checkbox"
                                                checked={this.state.isAll}
                                                name="demo"
                                                defaultValue="one"
                                                id="radio-three"
                                                className="form-radio"
                                            />
                                        </span>
                                    ) : (
                                        <span className="tick-radio position-relative d-inline-block">
                                            <input type="checkbox" name="demo" defaultValue="one" id="radio-three" className="form-radio" />
                                        </span>
                                    )}
                                </div>
                                <div className="w-30 font-weight-bold">
                                    <span>{T.t('r_firstname')}</span>
                                </div>
                                <div className="w-30 font-weight-bold">
                                    <span>{T.t('r_lastname')}</span>
                                </div>
                                <div className="w-30 font-weight-bold">
                                    <span>{T.t('r_username')}</span>
                                </div>
                            </div>
                            {
                            this.props.addStudentDatas?.results &&
                            this.props.addStudentDatas.results.length ? (
                                this.props.addStudentDatas.results.map((item: IStudents) => {
                                    return (
                                        <div className="question-row w-100" style={{ overflow: 'visible  !important' }} key={item.userId}>
                                            <div className="w-10 ">
                                                <span className="tick-radio position-relative d-inline-block">
                                                    {item.alreadyUsed ? (
                                                        <>
                                                            <Tooltip data={T.t('r_gen_exam_session_student_already_used')} position='top'>
                                                                <i
                                                                    className="material-icons mr-2"
                                                                    style={{ width: 20, height: 20, fontSize: 20 }}
                                                                >
                                                                    info
                                                                </i>
                                                            </Tooltip>

                                                            <input className="form-radio" style={{ display: 'none' }} />
                                                        </>
                                                    ) : (
                                                        <input
                                                            data-id={item.userId}
                                                            onChange={this.onSelectStudent}
                                                            type="checkbox"
                                                            name="demo"
                                                            defaultValue="one"
                                                            id="radio-three-u"
                                                            checked={
                                                                (!this.state.isAll &&
                                                                    this.state.selectedStudentIds.includes(item.userId)) ||
                                                                (this.state.isAll && !this.state.disAllowedStudentIds.includes(item.userId))
                                                                }
                                                            className="form-radio mr-2"
                                                        />
                                                    )}
                                                </span>
                                            </div>
                                            <div className="w-30 d-flex align-items-center">
                                                <label className="text-truncate text-dark mb-0">{item.firstName}</label>{' '}
                                            </div>
                                            <div className="w-30 d-flex align-items-center">
                                                <label className="text-truncate text-dark mb-0">{item.lastName}</label>{' '}
                                            </div>
                                            <div className="w-30 d-flex align-items-center">
                                                <label className="text-truncate text-dark mb-0">{item.userName}</label>{' '}
                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="d-flex flex-column align-items-center">
                                    <Announce title={T.t('r_no_record_found')} />
                                    <span className="mt-4 font-weight-bolder">{T.t('r_no_student_on_list')}</span>
                                </div>
                            )}
                        </div>
                    </div>
        )
    }

    public render() {
        return (
            <div
                className={'tab-pane fade' + (this.props.currentTab === '_sessionAddStudent' ? ' show active' : '')}
                style={{ width: '100%' }}
                role="tabpanel"
                aria-labelledby="all-users-tab"
            >
                <div className="container">
                    <div className="row justify-content-between align-items-center">
                        <div className="col-5" >
                            <div aria-hidden={true} onClick={() => this.handleClick()} className="k365-input date-picker">
                                <label className='input-label'>{T.t('r_gen_exam_session_search_student')}</label>
                                <SelectAsync
                                    isMulti={false}
                                    className='k365-select'
                                    isSearchable={true}
                                    requestType={'post'}
                                    parameter={{
                                        SearchedText: '',
                                        ExamId: this.props.examId,
                                        ExamSessionId: this.props.examSessionId,
                                        IsSelectAll: true,
                                        Page: 1,
                                        Take: 10,
                                        IsSelectAsync: true
                                    }}
                                    placeHolder={T.t('r_gen_exam_session_search_student')}
                                    url={'api/examsession/getstudents'}
                                    closeMenuOnScroll={false}
                                    closeMenuOnSelect={false}
                                    name={'examAddStudentsUserIds'}
                                    onChange={this.selectStudentOnChange}
                                    hasLocalization={true}
                                    setFieldOnlyValue={true}
                                    initialProcess={false}
                                    touched={ this.props.currentTab === '_sessionAddStudent' && this.state.getAllStudents}
                                />
                            </div>
                        </div>
                        <div className="col-3" style={{margin:'inherit'}}>
                            {this.state.isSelectAll ? (
                                <Button
                                    button_type='secondary'
                                    size='medium'
                                    onClick={this.addAllStudents}
                                    text={T.t('r_gen_exam_session_add_all_students')}
                                    iconPosition='left'
                                    materialicon='add'
                                    style={{minWidth: '-webkit-fill-available'}}
                                />
                            ) : (
                                <Button
                                    button_type='secondary'
                                    size='medium'
                                    onClick={this.selectAllStudents}
                                    text={T.t('r_gen_exam_session_get_all_students')}
                                    iconPosition='left'
                                    materialicon='add'
                                    style={{minWidth: '-webkit-fill-available'}}
                                />
                            )}
                        </div>
                        <div className=" col-2 " style={{margin:'inherit'}}>

                            <Button
                                button_type='secondary'
                                size='medium'
                                onClick={this.onClickItems.bind(this, 'Report')}
                                text={T.t('r_gen_exam_session_get_students')}
                                iconPosition='left'
                                materialicon='add'
                                style={{minWidth: '-webkit-fill-available'}}
                            />
                        </div>

                        <div className=" col-2 " style={{margin:'inherit'}}>

                            <Button
                                button_type='secondary'
                                size='medium'
                                onClick={this.clearList}
                                text={T.t('r_gen_exam_session_clean_list')}
                                iconPosition='left'
                                materialicon='delete'
                                style={{minWidth: '-webkit-fill-available'}}
                            />
                        </div>
                    </div>
                    <div className="row justify-content-end">
                        <div style={{ paddingRight: '0.5rem' }}>
                            {
                            this.props.addStudentDatas?.results &&
                            this.props.addStudentDatas.results.length > 0 &&
                            ((this.state.selectedStudentIds && this.state.selectedStudentIds.length > 0) || this.state.isAll) ? (

                                <Button
                                    button_type='primary'
                                    size='medium'
                                    onClick={this.addSelectedStudents}
                                    text={T.t('r_gen_exam_session_add_student')}
                                    iconPosition='left'
                                    materialicon='add'
                                />
                            ) : (
                                <Button
                                    button_type='primary'
                                    size='medium'
                                    text={T.t('r_gen_exam_session_add_student')}
                                    iconPosition='left'
                                    materialicon='add'
                                />
                            )}
                        </div>
                    </div>
                    {this.selectedStudentResults()}
                    {this.props.addStudentDatas?.results && this.props.addStudentDatas.results.length > 0 && (
                        <div className="row-options justify-content-end">
                                <div
                                    className="page-sorting d-flex align-items-center justify-content-center"
                                    style={{ marginTop: '5px' }}
                                />
                                <Paginate
                                    class={'custom-paginate'}
                                    filters={this.props.addStudentDatas.filters}
                                    onPageChange={this.onPageChange}
                                />
                            </div>
                    )}
                </div>
                {this.state.isAddStudentModalOpen && (
                <AddMultiStudentModal
                isProjectSubActivity={this.props}
                activityId={"3"}
                modalIsOpen={true}
                onClose={this.popUpClose}
                addMultiStudentsCallBack = {this.addMultiStudentsCallBack}
                />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IAddStudentModalProps): IAddStudentModalProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IAddStudentModalProps = Object.assign({}, ownProps, {
        addStudentDatas: state.examSession.addStudentDatas,
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        isDefaultUpdateStudent: state.examSession.isDefaultUpdateStudent,
        publishDatas: state.examSession.publishDatas,
        multiUsers: state.examSession.multiUsers,
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return (
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.examSession.addStudentDatas === prev.examSession.addStudentDatas &&
        next.examSession.isDefaultUpdateStudent === prev.examSession.isDefaultUpdateStudent &&
        next.examSession.publishDatas === prev.examSession.publishDatas &&
        next.examSession.multiUsers === prev.examSession.multiUsers
    );
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CAddStudentModal = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(AddStudentModal);

export default CAddStudentModal;
